/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { AIGeneralBlockCard } from '../../AIGeneralBlockCard';
import { Text } from '../../../atoms/Text/Text';
import './TimeoutRendererStyles.scss';
const baseClass = 'qmb-ui-TimeoutRenderer';
export function TimeoutRenderer({ block }) {
    const timeout = block;
    return (React.createElement(AIGeneralBlockCard, { variant: "error", sections: [
            {
                label: 'Request Timed Out',
                content: (React.createElement("div", { className: baseClass },
                    React.createElement(Text, { variant: "body" },
                        "Your query took too long to process (attempt ",
                        timeout.retry_count,
                        " of ",
                        timeout.max_retries,
                        ")."),
                    timeout.suggested_query && (React.createElement(Text, { variant: "body", className: `${baseClass}__suggestion` },
                        "Try a simpler query: \u201C",
                        timeout.suggested_query,
                        "\u201D"))))
            }
        ] }));
}
